import { borderRadius } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

export const InsightsIconContainer = styled.div<{ $isBearish: boolean }>`
  display: flex;
  position: relative;
  ${({ $isBearish }) =>
    $isBearish &&
    css`
      padding-top: 4px;
    `}
`;

export const StyledTooltipContainer = styled(TooltipContainer)`
  border: none;
  background: none;
  box-shadow: none;
  position: relative;
  max-width: 100%;
  padding: 0px 12px;
`;

export const NewInsightIndicator = styled.div`
  position: absolute;
  width: 4px;
  height: 4px;
  left: 14px;
  top: 2px;
  background-color: var(--icon-primary);
  ${borderRadius.rFull};
`;
